<template>  
  <div class="sellservicedelivery">
    <XR-head titleText="售后发货"></XR-head>
    <div class="delivery-form" v-if="!loaded">
      <mu-row gutter>
        <mu-select-field v-model="deliveryInfo.LogisticsCompanyId" fullWidth label="物流公司">
          <template v-for="logiticsItem in  logiticsList">
            <mu-menu-item :value="logiticsItem.Id" :title="logiticsItem.Name"></mu-menu-item>
          </template>
        </mu-select-field>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
        <div class="remark">      
          <mu-text-field  label="物流单号" hintText="请输入您的物流单号" v-model="deliveryInfo.DeliveryNo" fullWidth />
        </div>
        </mu-col>
      </mu-row>
    </div>
    <mu-row gutter v-if="!loaded">
      <mu-col width="100" tablet="50" desktop="33" class="button-row">
        <mu-raised-button label="确 定" class="submit" primary fullWidth @click="sellServiceOrderDelivery()" />
      </mu-col>
    </mu-row>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded:true,
      logiticsList:[],
      deliveryInfo:{
        SellServiceNo:this.$route.query.sellServiceNo,
        LogisticsCompanyId:0,
        DeliveryNo:''
      }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getLogiticsList()
  },
  methods: {
    getLogiticsList(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetLogisticsList"
      ).then(function(res) {
        if(!res.IsSuccess){     
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded=false
          ths.$refs.XRtoast.hide()
          ths.logiticsList = res.Data
        }
      });
    },
    sellServiceOrderDelivery(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/SellServiceOrderBuyDelivery",
        JSON.stringify(this.deliveryInfo)
      ).then(function(res) {
        if(!res.IsSuccess){     
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>

<style>
.sellservicedelivery .delivery-form{
  background: white;
  padding: 10px;
}
.sellservicedelivery .remark{
  background: white;
}
.sellservicedelivery .button-row{  
  padding: 40px 20px 0 20px;
}
.sellservicedelivery .submit{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sellservicedelivery.vue